import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import { AuthProvider } from './Context/AuthContext';
import AppLandingPage from './Components/AppLandingPage';
import SaveTheDate from './Components/SaveTheDate';
import CustomSite from './Components/custom_site/CustomSite';
import RSVP from './Components/RSVP';
import Open from './Components/Open';
import RSVPPreview from './Components/RSVPPreview';
import Schedule from './Components/Schedule';
import AdRedirect from './Components/AdRedirect';
import PhotoAlbumRedirect from './Components/PhotoAlbumRedirect';
import PhotoAlbumLandingPage from './Components/PhotoAlbumLandingPage';
import CancellationRequest from './Components/CancellationRequest';
import Terms from './Components/Terms';
import PrivacyPolicy from './Components/PrivacyPolicy';
import BillingWeb from './Components/BillingWeb';
import BillingSuccess from './Components/BillingSuccess';
import SubscribedFeedback from './Components/SubscribedFeedback';
import FeaturesIndex from './Components/marketing/FeaturesIndex';
import FeaturePage from './Components/marketing/FeaturePage';
import Pricing from './Components/marketing/Pricing';
import BlogIndex from './Components/blogs/BlogIndex';
import BlogPost from './Components/blogs/BlogPost';
import GuestUpload from './Components/GuestUpload';
import { usePageTracking } from "./Analytics/usePageTracking";

function TrackedRoutes() {
  usePageTracking();

  return (
    <Routes>
      <Route path='/' element={<AppLandingPage />} />
      <Route path='/features' element={<FeaturesIndex />} />
      <Route path='/features/:slug' element={<FeaturePage />} />
      <Route path='/pricing' element={<Pricing />} />
      <Route path='/upload/:weddingId' element={<GuestUpload />} />
      <Route path='/photo-album/redirect' element={<PhotoAlbumRedirect />} />
      <Route path='/photo-album' element={<PhotoAlbumLandingPage />} />
      <Route path='/:friendlyURL' element={<CustomSite />} />
      <Route path='/save-the-date/:friendlyURL' element={<SaveTheDate />} />
      <Route path='/rsvp/:guestId' element={<RSVP />} />
      <Route path='/rsvp-preview/:clientId' element={<RSVPPreview />} />
      <Route path='/blog' element={<BlogIndex />} />
      <Route path='/blog/:slug' element={<BlogPost />} />
      <Route path='/open' element={<Open />} />
      <Route path='/redirect' element={<AdRedirect />} />
      <Route path='/schedule/:friendlyURL' element={<Schedule />} />
      <Route path='/cancellation-request' element={<CancellationRequest />} />
      <Route path='/subscribed-feedback' element={<SubscribedFeedback />} />
      <Route path='/terms' element={<Terms />} />
      <Route path='/privacy-policy' element={<PrivacyPolicy />} />
      <Route path='/billing' element={<BillingWeb />} />
      <Route path='/billing-success' element={<BillingSuccess />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <TrackedRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
